import { ChatMessage } from '../entity';

export class ChatMessageEditEvent {
  constructor(public message: ChatMessage) {}
}
